/**
 * @param {number} viewYear
 * @param {number} viewMonth0 0–11
 * @returns {{ date: Date, inMonth: boolean }[]}
 */
export function buildMonthGrid(viewYear, viewMonth0) {
  const first = new Date(viewYear, viewMonth0, 1);
  const jsDay = first.getDay();
  const mondayOffset = (jsDay + 6) % 7;
  const daysInMonth = new Date(viewYear, viewMonth0 + 1, 0).getDate();
  /** @type {{ date: Date, inMonth: boolean }[]} */
  const cells = [];

  for (let i = 0; i < mondayOffset; i += 1) {
    const prevDays = new Date(viewYear, viewMonth0, 0).getDate();
    const dayNum = prevDays - mondayOffset + i + 1;
    cells.push({ date: new Date(viewYear, viewMonth0 - 1, dayNum), inMonth: false });
  }
  for (let day = 1; day <= daysInMonth; day += 1) {
    cells.push({ date: new Date(viewYear, viewMonth0, day), inMonth: true });
  }
  while (cells.length % 7 !== 0) {
    const last = cells[cells.length - 1].date;
    const next = new Date(last.getFullYear(), last.getMonth(), last.getDate() + 1);
    cells.push({ date: next, inMonth: false });
  }
  return cells;
}

/** @param {string} iso YYYY-MM-DD */
export function dateFromIso(iso) {
  if (!iso || !/^\d{4}-\d{2}-\d{2}$/.test(iso)) return null;
  const [y, m, d] = iso.split('-').map(Number);
  const dt = new Date(y, m - 1, d);
  if (Number.isNaN(dt.getTime()) || dt.getFullYear() !== y || dt.getMonth() !== m - 1 || dt.getDate() !== d)
    return null;
  return dt;
}

/** @param {Date} d */
export function isoFromDate(d) {
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${y}-${m}-${day}`;
}

/** @param {Date} a @param {Date} b */
export function sameCalendarDay(a, b) {
  return (
    a.getFullYear() === b.getFullYear() && a.getMonth() === b.getMonth() && a.getDate() === b.getDate()
  );
}

/** @param {string} iso @param {string} locale BCP-47 */
export function formatDisplayIso(iso, locale) {
  const d = dateFromIso(iso);
  if (!d) return '';
  return new Intl.DateTimeFormat(locale, { day: '2-digit', month: '2-digit', year: 'numeric' }).format(d);
}

/** @type {Map<string, string[]>} */
const weekdayNarrowsCache = new Map();

/** Monday-first narrow weekday labels (cached per locale). */
export function weekdayNarrows(locale) {
  const key = locale || 'en-US';
  const hit = weekdayNarrowsCache.get(key);
  if (hit) return hit;

  const refMonday = new Date(2024, 0, 1);
  const out = [];
  for (let i = 0; i < 7; i += 1) {
    const d = new Date(refMonday);
    d.setDate(refMonday.getDate() + i);
    const n = new Intl.DateTimeFormat(locale, { weekday: 'narrow' }).format(d);
    out.push(n.length ? n[0].toUpperCase() : '');
  }
  weekdayNarrowsCache.set(key, out);
  return out;
}
